import { FC } from 'react'
import {
  AutocompleteInput,
  BooleanInput,
  Create,
  NumberInput,
  ReferenceInput,
  SimpleForm,
  required,
  useTranslate,
} from 'react-admin'
import { useLocation } from 'react-router-dom'
import InputAdornment from '@mui/material/InputAdornment'
import { SaveOnlyToolbar } from '../../components'
import LinkServerConfigsSection from './LinkServerConfigsSection'
import LinkVariablesSection from './LinkVariablesSection'

const OrganizationWorkflowLinkCreate: FC = () => {
  const location = useLocation()
  const translate = useTranslate()
  const hasPrefill = !!(location.state as Record<string, unknown> | undefined)?.record

  return (
    <Create redirect="edit">
      <SimpleForm
        defaultValues={{ enabled: true }}
        toolbar={hasPrefill ? <SaveOnlyToolbar alwaysEnable /> : undefined}
      >
        <ReferenceInput source="organization_id" reference="organization">
          <AutocompleteInput
            optionText="display_name"
            label="data.organization"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
        <ReferenceInput source="workflow_id" reference="workflow">
          <AutocompleteInput
            optionText="display_name"
            label="data.workflow"
            fullWidth
            validate={required()}
          />
        </ReferenceInput>
        <BooleanInput source="enabled" />
        <NumberInput
          source="cost_per_workflow_execution"
          label="resources.organization_workflow_link.costPerWorkflowExecution"
          helperText={translate('resources.organization_workflow_link.costPerWorkflowExecutionHelp')}
          min={0}
          step={0.0001}
          fullWidth
          InputProps={{ startAdornment: <InputAdornment position="start">€</InputAdornment> }}
        />
        <LinkVariablesSection />
        <LinkServerConfigsSection />
      </SimpleForm>
    </Create>
  )
}

export default OrganizationWorkflowLinkCreate
